angular.module('ikeweb.error', ['ikeweb.routes']);



//////////////////
// WEBPACK FOOTER
// ./src/client/error/error.module.js
// module id = 437
// module chunks = 0